import { ArrowUpRight, ArrowDownRight } from "lucide-react";

function formatNumber(n) {
  if (n == null) return "0";
  return n.toLocaleString("pt-BR");
}

function formatCurrency(v) {
  if (v == null) return "R$ 0,00";
  return "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("pt-BR");
}

export default function DoletasHistory({ transactions }) {
  if (!transactions || transactions.length === 0) return null;

  var items = [];
  for (var i = 0; i < transactions.length; i++) {
    var tx = transactions[i];
    var isPositive = tx.amount >= 0;
    items.push(
      <div key={tx.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-testid={"tx-item-" + tx.id}>
        <div className="flex items-center gap-3">
          <div className={"w-8 h-8 rounded-lg flex items-center justify-center " + (isPositive ? "bg-emerald-100" : "bg-red-100")}>
            {isPositive ? <ArrowUpRight className="w-4 h-4 text-emerald-600" /> : <ArrowDownRight className="w-4 h-4 text-red-500" />}
          </div>
          <div>
            <p className="text-sm font-medium text-[#0A2F3D]">{tx.source_description}</p>
            <p className="text-xs text-gray-400">{formatDate(tx.created_at)}</p>
          </div>
        </div>
        <div className="text-right">
          <p className={"text-sm font-bold " + (isPositive ? "text-emerald-600" : "text-red-500")}>
            {isPositive ? "+" : ""}{formatNumber(tx.amount)}
          </p>
          <p className="text-xs text-gray-400">{formatCurrency(tx.money_value)}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 lg:p-5">
      <h4 className="font-semibold text-[#0A2F3D] text-sm mb-3">Ultimas Movimentacoes</h4>
      <div className="space-y-2">{items}</div>
    </div>
  );
}
